// Freezes page scroll behind the mobile overlay and puts the page back where
// it was when the overlay goes.
export class BodyScrollLock {
  private locked = false
  private scrollPosition = 0

  lock() {
    if (this.locked) return
    this.locked = true
    this.scrollPosition = window.scrollY
    document.documentElement.style.overflow = 'hidden'
    document.body.style.overflow = 'hidden'
  }

  // Guarded because callers run this from disconnect() on every Turbo
  // navigation and on every breakpoint crossing; an unconditional scrollTo
  // would yank the page to a stale offset.
  unlock() {
    if (!this.locked) return
    this.locked = false
    document.documentElement.style.overflow = ''
    document.body.style.overflow = ''
    window.scrollTo(0, this.scrollPosition)
  }
}
